import React from 'react';
import CommonDatePicker from 'components/_common/DatePicker';
import { stringToDate } from 'utils/Date.util';
import { getReceptionStatus, getReceptionType } from 'enums/reception.enum';

const SearchFilter = ({
    searchParams,
    onSearchChange,
    onSearch,
    onClearFilter,
    onClearManufactureMonthFilter,
    onTodaySearch,
    todayButtonName,
    showStatusFilter = true,
    showTypeFilter = true,
    showDateRange = true,
    showManufactureMonthRange = false,
    showModelName = false,
    showRepairNote = false,
    showDateType = false,
    showEstimateAmount = false,
    dateTypeOptions = [],
    placeholder = "고객명, 연락처, 비고 등 검색",
    additionalFilters = null,
    onExcelDownload = null,
    onOpenCreate = null,
}) => {
    const statusOptions = getReceptionStatus();
    const typeOptions = getReceptionType();

    console.log("typeOptions", typeOptions);

    const handleInputChange = (field: string, value: string) => {
        onSearchChange(field, value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            onSearch();
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSearch();
    };

    return (
        <div className="card card-default">
            <div className="card-body" style={{ padding: '12px 16px' }}>
                {/* 첫 번째 행 - 주요 필터들 */}
                <form onSubmit={handleSubmit}>
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        gap: '16px',
                        marginBottom: '12px'
                    }}>

                        {/* 처리상황 */}
                        {showStatusFilter && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <label style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#6b7280',
                                    marginBottom: 0,
                                    whiteSpace: 'nowrap'
                                }}>
                                    처리상황
                                </label>
                                <div className='form-control form-control-sm'>
                                    <select
                                        className="form-select form-select-sm"
                                        style={{ width: '100%' }}
                                        value={searchParams.status || ''}
                                        onChange={(e) => handleInputChange('status', e.target.value)}
                                    >
                                        <option value="">전체</option>
                                        {statusOptions.map(status => (
                                            <option key={status.value} value={status.value}>
                                                {status.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}

                        {/* 처리유형 */}
                        {showTypeFilter && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <label style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#6b7280',
                                    marginBottom: 0,
                                    whiteSpace: 'nowrap'
                                }}>
                                    처리유형
                                </label>
                                <div className='form-control form-control-sm'>
                                    <select
                                        className="form-select form-select-sm"
                                        style={{ width: '100%' }}
                                        value={searchParams.type || ''}
                                        onChange={(e) => handleInputChange('type', e.target.value)}
                                    >
                                        <option value="">전체</option>
                                        {typeOptions.map(type => (
                                            <option key={type.value} value={type.value}>
                                                {type.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}

                        {/* 접수일자 선택 */}
                        {showDateType && dateTypeOptions.length > 0 && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <label style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#6b7280',
                                    marginBottom: 0,
                                    whiteSpace: 'nowrap'
                                }}>
                                    검색일자
                                </label>
                                <div className='form-control form-control-sm'>
                                    <select
                                        className="form-select form-select-sm"
                                        style={{ width: '100%' }}
                                        value={searchParams.dateType || dateTypeOptions[0]?.value}
                                        onChange={(e) => handleInputChange('dateType', e.target.value)}
                                    >
                                        {dateTypeOptions.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}

                        {/* 기간 선택 */}
                        {showDateRange && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <label style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#6b7280',
                                    marginBottom: 0,
                                    whiteSpace: 'nowrap'
                                }}>
                                    기간
                                </label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <CommonDatePicker
                                        selected={stringToDate(searchParams.startDate)}
                                        onChange={(date) => handleInputChange('startDate', date)}
                                        placeholderText="YYYY-MM-DD"
                                        maxDate={stringToDate(searchParams.endDate)}
                                    />
                                    <span style={{ fontSize: '14px', color: '#6b7280' }}>~</span>
                                    <CommonDatePicker
                                        selected={stringToDate(searchParams.endDate)}
                                        onChange={(date) => handleInputChange('endDate', date)}
                                        placeholderText="YYYY-MM-DD"
                                        minDate={stringToDate(searchParams.startDate)}
                                    />
                                    {onTodaySearch && (
                                        <button
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={onTodaySearch}
                                            title="오늘 날짜로 검색"
                                            style={{ marginLeft: '4px', padding: '4px 8px' }}
                                        >
                                            {todayButtonName}
                                        </button>
                                    )}
                                    {onClearFilter && (
                                        <button
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={onClearFilter}
                                            title="초기화"
                                            style={{ marginLeft: '4px', padding: '4px 8px' }}
                                        >
                                            초기화
                                        </button>
                                    )}

                                    {showEstimateAmount && (
                                        <>
                                            <label style={{
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                color: '#6b7280',
                                                marginBottom: 0,
                                                whiteSpace: 'nowrap'
                                            }}>
                                                견적금액
                                            </label>
                                            {/* <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    style={{ width: '100px', paddingRight: '32px' }}
                                                    placeholder="0"
                                                    value={searchParams.beginEstimateAmount || ''}
                                                    onChange={(e) => handleInputChange('beginEstimateAmount', e.target.value)}
                                                />
                                            </div>
                                            ~ */}
                                            <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm"
                                                    style={{ width: '100px', paddingRight: '32px' }}
                                                    placeholder="10000"
                                                    value={searchParams.endEstimateAmount || ''}
                                                    onChange={(e) => handleInputChange('endEstimateAmount', e.target.value)}
                                                />
                                            </div>
                                        </>
                                    )}

                                </div>
                            </div>
                        )}

                    </div>

                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        gap: '16px',
                        marginBottom: '12px'
                    }}>

                        {/* 제조년월 입력 */}
                        {showModelName &&
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <label style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#6b7280',
                                    marginBottom: 0,
                                    whiteSpace: 'nowrap'
                                }}>
                                    보일러명
                                </label>
                                <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                                    <input
                                        type="search"
                                        className="form-control form-control-sm"
                                        style={{ width: '280px', paddingRight: '32px' }}
                                        placeholder={"보일러명"}
                                        value={searchParams.modelName || ''}
                                        onChange={(e) => handleInputChange('modelName', e.target.value)}
                                        onKeyPress={handleKeyPress}
                                    />
                                </div>
                            </div>
                        }

                        {showRepairNote &&
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <label style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#6b7280',
                                    marginBottom: 0,
                                    whiteSpace: 'nowrap'
                                }}>
                                    수리내역
                                </label>
                                <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                                    <input
                                        type="search"
                                        className="form-control form-control-sm"
                                        style={{ width: '280px', paddingRight: '32px' }}
                                        placeholder={"수리내역"}
                                        value={searchParams.repairNote || ''}
                                        onChange={(e) => handleInputChange('repairNote', e.target.value)}
                                        onKeyPress={handleKeyPress}
                                    />
                                </div>
                            </div>
                        }

                        {showManufactureMonthRange && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <label style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#6b7280',
                                    marginBottom: 0,
                                    whiteSpace: 'nowrap'
                                }}>
                                    제조년월
                                </label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <CommonDatePicker
                                        selected={stringToDate(searchParams.startManufactureMonth)}
                                        onChange={(date) => handleInputChange('startManufactureMonth', date)}
                                        placeholderText="YYYY-MM"
                                        maxDate={stringToDate(searchParams.endManufactureMonth)}
                                        mode="monthly"
                                    />
                                    <span style={{ fontSize: '14px', color: '#6b7280' }}>~</span>
                                    <CommonDatePicker
                                        selected={stringToDate(searchParams.endManufactureMonth)}
                                        onChange={(date) => handleInputChange('endManufactureMonth', date)}
                                        placeholderText="YYYY-MM"
                                        minDate={stringToDate(searchParams.startManufactureMonth)}
                                        mode="monthly"
                                    />

                                    {onClearManufactureMonthFilter && (
                                        <button
                                            type='button'
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={onClearManufactureMonthFilter}
                                            title="초기화"
                                            style={{ marginLeft: '4px', padding: '4px 8px' }}
                                        >
                                            초기화
                                        </button>
                                    )}

                                </div>
                            </div>
                        )}

                    </div>

                    {/* 세 번째 행 - 검색어 및 추가 필터 */}
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        gap: '16px'
                    }}>
                        {/* 검색어 입력 */}
                        {searchParams &&
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <label style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#6b7280',
                                    marginBottom: 0,
                                    whiteSpace: 'nowrap'
                                }}>
                                    검색
                                </label>
                                <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                                    <input
                                        type="search"
                                        className="form-control form-control-sm"
                                        style={{ width: '280px', paddingRight: '32px' }}
                                        placeholder={placeholder}
                                        value={searchParams.keyword || ''}
                                        onChange={(e) => handleInputChange('keyword', e.target.value)}
                                        onKeyPress={handleKeyPress}
                                    />
                                </div>
                            </div>
                        }

                        {/* 검색 버튼 */}
                        {searchParams &&
                            <div >
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={onSearch}
                                    style={{ padding: '6px 16px' }}
                                >
                                    <i className="fas fa-search" style={{ marginRight: '4px' }}></i>
                                    검색
                                </button>
                            </div>
                        }

                        {/* 추가 필터들 */}
                        {additionalFilters}

                        {onOpenCreate &&
                            <div style={{ marginLeft: 'auto' }}>
                                <button
                                    className="btn btn-primary btn-sm"
                                    onClick={onOpenCreate}
                                    style={{ padding: '6px 16px' }}
                                >
                                    <i className="fas fa-plus me-1" style={{ marginRight: '4px' }}></i>
                                    접수등록
                                </button>
                            </div>
                        }

                        {onExcelDownload &&
                            <div style={onOpenCreate ? {} : { marginLeft: 'auto' }}>
                                <button
                                    className="btn btn-outline-success btn-sm"
                                    onClick={onExcelDownload}
                                    style={{ padding: '6px 16px' }}
                                    type='button'
                                >
                                    <i className="fas fa-download me-1" style={{ marginRight: '4px' }}></i>
                                    엑셀 다운로드
                                </button>
                            </div>
                        }

                        {/* 도움말 텍스트 */}
                        {/* <div style={{ marginLeft: 'auto' }}>
                            <small style={{ color: '#9ca3af', fontSize: '12px' }}>
                                * 검색어 입력 후 Enter 키를 누르거나 검색 버튼을 클릭하세요
                            </small>
                        </div> */}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SearchFilter;